export const libelleEts = {
    "POLYTECH": "Ecole Supérieure Polytech Diamniadio",
    "TECNA": "UFR des Technologies de la Communication Numérique et de l'Audiovisuel",
    "STA": "UFR des Sciences et Technologies Avancées",
    "SEG": "UFR des Sciences Economiques et de Gestion",
    "CFVUCPL" : "Centre de Formation aux Valeurs Universitaires et Citoyennes et à la Pratique des Langues"
};

export const etabsPATS = {
    "Agence Comptable" : ["Agence Comptable"],
    "Bibliothèque Universitaire" : ["Bibliothèque Universitaire"],
    "Rectorat" : ["Rectorat"],
    "STA" : "UFR des Sciences et Technologies Avancées"  ,
    "TECNA" : "UFR des Technologies de la Communication Numérique et de l'Audiovisuel"  ,
    "POLYTECH" : "Ecole Supérieure Polytech Diamniadio" ,
    "SEG" : "UFR des Sciences Economiques et de Gestion" ,
    "UNIPOD" : "Pôle universitaire d'Innovation et de Technologie (UNIPOD)",
};
export const postesPats = {
    "Assistante de Direction": ["Rectorat"],
    "Secretaire": ["STA", "TECNA", "SEG", "POLYTECH"],
    "Technicien de Laboratoire": ["STA"],
    "Technicien Superieure Dessinateur Geometre Topographe": ["POLYTECH"],
};

export const domaines = [
    // "Informatique",
    // "Gestion",
    // "Mathématiques",
    // "Economie",
    // "Physique",
    // "Finance",
    // "Génie côtier, Portuaire et Maritime",
    // "Anglais",
    "Communication",
    // "Infographie/Design",
    // "Chimie Environnementale",
    // "Systèmes Electriques et Energétiques",
    // "Aménagement et développement territorial",
    // "Architecture",
    // "Urbanisme",
    // "Infrastructures et Génie Civil",
    // "Technologies Agroalimentaires",
    // "Production végétale",
    // "Mines et Géologie",
    // "Hydraulique Assainissement",
];

export const postesPer = {
    "Informatique": {
        // "Génie logiciel et Sécurité des systèmes d'information": ["STA"],
        // "Data Sciences et intelligence artificielle": ["STA"],
        // "Informatique, spécialité. Génie Logiciel et Administration Système.": ["STA"],
        // "Programmation, analyse de données et analyse de réseaux": ["TECNA"],
        // "Génie Logiciel": ["POLYTECH"],
        // "Réseaux et Télécommunications": ["POLYTECH"], 
            "Ingénierie informatique, spécialité : génie logiciel": ["POLYTECH"],
    },
    "Gestion": {
        "Comptabilité et contrôle de gestion": ["SEG"],
        "Marketing": ["SEG","POLYTECH"],
        "Management": ["SEG"],
        "Comptabilité": ["POLYTECH"],
    },
    "Physique": {
        // "Physique des Polymères": ["STA"],
        // "Physique, Spécialité : Energies renouvelables": ["STA"],
        // "Physique, Energie électromagnétique, Optique, Matériaux, Semi-conducteurs": ["STA"],
        // "Physique statistique, Thermodynamique et Matière dense": ["STA"],
        // "Physique de l'Atmosphère et de l'Océan (Sciences de la mer et technologies spatiales)": ["STA"],
    },
    "Mathématiques": {
        // "Mathématiques Statistiques": ["SEG"],
        // "Mathématiques de la décision": ["SEG"],
        // "Mathématiques appliquées": ["STA"],
        // "Modélisation et systèmes complexes": ["STA"],
        // "Probabilité appliquée": ["STA"],
        "Mathématiques appliquées, spécialité : Statistique, Analyse des Données Massives (Big Data) et/ou Économétrie": ["STA"],
    },
    "Economie": {
        "Macroéconomie ou analyse économique": ["SEG"],
        "Economie Quantitative": ["SEG"],
        "Economie du Développement": ["SEG"],
        "Microéconomie ou économie industrielle": ["SEG"],
        "Economie avancée": ["STA"],
    },
    "Finance": {
        // "Finance et Comptabilité": ["STA"],
        // "Finance d'entreprise": ["SEG"],
        // "Gestion financière et fiscalité": ["SEG"],
        "Gestion financières et Fiscalité": ["SEG"],
        // "Finance": ["POLYTECH"],
    },
    "Génie côtier, Portuaire et Maritime" : {
        "Génie côtier et Infrastructures de protection côtière": ["STA"],
    },
    "Communication": {
        // "Production audiovisuelle": ["TECNA"],
        "Communication et médias numériques": ["TECNA"],
        // "Communication des organisations": ["TECNA"],
        // "Communication, numérique et société": ["TECNA"],
        // "Théories de la Communication et médias numériques": ["TECNA"],
        // "Journalisme numérique, mobile et narration interractive": ["TECNA"],
        // "Médiation et Communication scientifique et technique": ["TECNA"],
    },
    "Infographie/Design" : {
        "graphisme-Arts numériques" : ["TECNA"],
        "Design et animation" : ["TECNA"],
        // "Design graphique, identité visuelle et maquettage": ["TECNA"],
        // "Motion Design et Animation 2D/3D": ["TECNA"],
        // "UX/UI Design": ["TECNA"],
        // "Illustration numérique et design narratif": ["TECNA"],
        // "Production audiovisuelle": ["TECNA"],
        // "3D, environnements virtuels et conception de jeux vidéo ": ["TECNA"],
    },
    "Chimie Environnementale" : {
        "Chimie environnementale, géochimie des roches et sols, chimie de l'eau, analyses physico-chimiques et métaux lourds": ["POLYTECH"],
    },
    "Hydraulique Assainissement" : {
        "Physique/Hydraulique": ["POLYTECH"],
    },
    "Mines et Géologie" : {
        // "Exploitation minière, ingénierie minière, économie et environnement miniers": ["POLYTECH"],
        // "Sédimentologie - Stratigraphie - Environnements sédimentaires - Dynamique côtière et fluviatile": ["POLYTECH"],
        "GENIE MINIER ET EXPLOITATION MINIERE": ["POLYTECH"]
    },
    "Technologies Agroalimentaires" : {
        "Zootechnie": ["POLYTECH"],
        "Biotechnologie alimentaire": ["POLYTECH"],
    },
    "Production végétale" : {
        "Agronomie et production végétale": ["POLYTECH"],
        "Horticulture": ["POLYTECH"],
    },
    "Infrastructures et Génie Civil" : {
        "Génie Civil": ["POLYTECH"],
    },
    "Systèmes Electriques et Energétiques" : {
        "Génie Electrique": ["POLYTECH"],
    },
    "Aménagement et développement territorial" : {
        "Planification, promotion, attractivité, marketing et développement des territoires": ["POLYTECH"],
    },
    "Architecture" : {
        "Architecture, Urbanisme": ["POLYTECH"],
    },
    "Urbanisme" : {
        "Plans, opérations d'urbanisme, techniques et outils d'urbanisme": ["POLYTECH"],
    },
    "Anglais" : {
        "Anglais de spécialité": ["CFVUCPL"],
    },
};
export const type_postes = ["PER", "PATS", "Vacataire"];

